"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _AngleRight = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/AngleRight"));

// Generated by script, don't edit it please.
var AngleRight = (0, _createSvgIcon["default"])({
  as: _AngleRight["default"],
  ariaLabel: 'angle right',
  category: 'legacy',
  displayName: 'AngleRight'
});
var _default = AngleRight;
exports["default"] = _default;
module.exports = exports.default;